import BaseController from 'lib/base-controller';
import Slider from 'lib/slider';

import CityTemplate from 'templates/city.html';
import BerlinData from 'data/cities/berlin.json';
import AmsterdamData from 'data/cities/amsterdam.json';
import LondonData from 'data/cities/london.json';
import googleMapStyles from 'data/google-maps.json';

export default class CityController extends BaseController {

    /**
     * constructor
     */
    constructor (props, renderDone) {
        super();

        this.template = CityTemplate;
        this.context = this.getData(props.name);
        this.renderDone = renderDone;

        window.initMap = this.initMap.bind(this);

        this.render();
    }

    afterRender () {
        super.afterRender();

        this.loadGoogleMaps();
        this.initSlider();
        this.loadImage();
    }

    loadImage () {
        let image = document.createElement('img');

        image.onload = this.renderDone;

        image.src = '/media/img/cities/' + this.context.slug + '_hero.jpg';

        if (image.complete) {
            this.renderDone();
        }
    }

    initSlider () {
        new Slider(document.querySelector('[data-slider]'));
    }

    getData (name) {
        const data = {
            berlin: BerlinData,
            amsterdam: AmsterdamData,
            london: LondonData,
        }

        return data[name];
    }

    initMap () {
        let mapOptions = {
            zoom: 15,
            center: new google.maps.LatLng(52.369975, 4.880136),
            styles: googleMapStyles,
            disableDefaultUI: true,
            scrollwheel: false,
        }

        this.map = new google.maps.Map(document.querySelector('.js-map'), mapOptions);

        this.addMarkers();
    }

    addMarkers () {
        this.markers = [];

        let bounds = new google.maps.LatLngBounds();

        this.context.hotspots.forEach((hotspot, index) => {
            this.markers[index] = new google.maps.Marker({
                position: new google.maps.LatLng(hotspot.lat, hotspot.long),
                map: this.map,
                title: hotspot.name,
                icon: {
            		url: `/media/svg/${hotspot.type}.svg`,
            		scaledSize: new google.maps.Size(36, 36)
            	}
            });

            bounds.extend(this.markers[index].getPosition());
        });

        this.map.fitBounds(bounds);
    }

    loadGoogleMaps () {
        if (window.google) {
            return this.initMap();
        }

        let script = document.createElement("script");

        script.type = "text/javascript";
        document.getElementsByTagName("head")[0].appendChild(script);
        script.src = 'http://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyBO-Yu8BfneSsKwBunu-lWEB4-z_IeS-iM&callback=initMap';
    }
}



// WEBPACK FOOTER //
// ./controllers/city.js